<template>
  <div class="goods">
    <div class="goodsList">
      <ol class="goodsMenu">
        <li v-for="(item, index) in itemList" :key="index" :index="item.path" slot="title"
          @click="item.title === currentItem.title ? getNodata() : getCgoods(item)">
          {{ item.name }}</li>
      </ol>
      <div class="goodsOnPage" @scroll="handleScroll" ref="goodsOnpage">
        <!-- <router-view></router-view> -->
        <goodsListOne :tabledata="adgoodsData" :selectAllid="ids" @update-selected="updateSelected"></goodsListOne>
        <div class="buyC">
          <div @click="getAllid">全 选</div>
          <div @click="submitOrder">添加订单</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goodsListOne from '@/components/goodsListOne.vue';

export default {
  components: {
    goodsListOne
  },
  props: {   //向外交互
    // itemList: {
    //   type: Array,
    //   default: () => []
    // },
  },
  data() {
    return {
      itemList: [],
      adgoodsData: [],
      ids: [],
      page: 1,  // 当前页码
      scrollTimeout: null,
      currentItem: '',
    }
  },
  computed: {

  },
  created() {
    this.getadlist();
  },
  methods: {
    //获取目录数据
    getadlist() {

      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const userage = userInfo.age;
      const usersex = userInfo.sex;

      this.$axios.get('/goods/adlist')
        .then(res => {
          if (res.data.status === 200) {
            if (userage >= 18 && usersex == 3) {
              this.itemList = res.data.results
            } else {
              // 如果年龄小于18并且性别正常则显示筛选后的全年龄列表
              this.itemList = res.data.results.filter(item => item.grad == '18-')
            }
          } else { console.log('err') }
        })
    },

    getNodata() {
      return
    },
    //获取商品数据
    getCgoods(item) {
      if (this.adgoodsData.length == 0 || item.title != this.adgoodsData[0].anime) {
        this.page = 1;
        this.$refs.goodsOnpage.scrollTop = 0;
        // console.log(this.page)
      }
      this.$axios.get(`/goods/goodslist?anime=${item.title}&page=${this.page}`)
        .then(res => {
          if (res.data.status === 200) {
            this.currentItem = item;
            if (this.adgoodsData.length != 0) {
              this.adgoodsData = this.adgoodsData.filter(goods => goods.anime === item.title);
              const adNewData = res.data.results
              this.adgoodsData = [...this.adgoodsData, ...adNewData]
              // console.log(this.adgoodsData)
            } else {
              this.adgoodsData = res.data.results;
            }
          }
        }).catch(err => {
          console.log(err); // Fix the error handling
        })
    },

    // 滚动事件处理函数，使用节流来减少滚动时事件触发频率
    handleScroll(event) {
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }

      this.scrollTimeout = setTimeout(() => {
        let distance = 50;
        const bottom = event.target.scrollHeight - distance <= event.target.scrollTop + event.target.clientHeight;
        if (bottom) {  // 到底部且没有在加载
          console.log('到底了')
          this.page += 1;  // 增加页码
          if (this.currentItem) {
            this.getCgoods(this.currentItem);  // 请求加载更多数据
          }
        }
      }, 500); // 设置一个200ms的节流间隔
    },

    getAllid() {
      if (this.ids.length == this.adgoodsData.length) {
        this.ids = []
      } else {
        // 获取所有id
        this.ids = this.adgoodsData.map(item => item.gooid);
      }
    },
    updateSelected(newSelectedIds) {
      // 接收子组件传回的更新选中的商品id
      this.ids = newSelectedIds;
    },

    // 提交订单（修正后的方法）
    submitOrder() {
      if (localStorage.userInfo) {
        if (this.ids.length === 0) {
          alert("请先选择商品");
          return;
        }

        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        // 向后端发送请求，添加订单
        this.$axios.post('/goods/add', { ids: this.ids, userid: userInfo.id })
          .then(res => {
            if (res.data.status === 200) {
              // alert(res.data.message); // 订单添加成功
              this.ids = [];
            }
          })
          .catch(error => {
            console.error('Error:', error.response.data);
            alert("添加订单失败");
          });
      } else {
        alert('未登录，请先登录')
      }

    },
  },
}
</script>

<style scoped lang="scss">
.goods {
  width: 100%;
  height: 100%;
  /* background-color: blue; */
  position: relative;

  .goodsList {
    width: 100%;
    height: 100%;
    /* background-color: blue; */
    display: flex;

    .goodsMenu {
      width: 20%;
      height: 100%;
      background-color: rgb(128, 53, 0);
      list-style: none;
      overflow: auto;

      li {
        display: block;
        width: 100%;
        height: 350rem;
        font-size: 60rem;
        text-align: center;
        line-height: 350rem;
        color: rgb(189, 189, 189);
        font-weight: 800;
        border: 10rem solid rgb(128, 124, 124);
      }
    }

    .goodsMenu::-webkit-scrollbar {
      display: none;
      /* 默认情况下隐藏滚动条 */
    }

    .goodsOnPage {
      width: 80%;
      height: 100%;
      // background-color: violet;
      background: url(../../assets/beijing2.jpg) center/100%;
      /* display: flex; */
      overflow: auto;
      padding-bottom: 8vh;

      .buyC {
        width: 80%;
        height: 8vh;
        background-color: pink;
        position: absolute;
        bottom: 0;
        display: flex;

        div {
          flex: 1;
          border: 1rem solid gainsboro;
          font-size: 3vh;
          text-align: center;
          line-height: 8vh;
          color: rgb(73, 63, 2);
          font-weight: 800;
        }
      }
    }

    .goodsOnPage::-webkit-scrollbar {
      display: none;
    }
  }


}
</style>